import { FC } from 'react'
import { useTranslation } from 'next-i18next'

import { DummyProgress } from '../../common/components/DummyProgress'
import {
  ProgressStepContainer,
  ProgressStepTitleAndDescription,
} from '../../common/components/ProgressStep'

type StepTwoProps = {
  isCompleted: boolean

  className?: string
}

export const FullLoadingProgress: FC<StepTwoProps> = ({ isCompleted, className }) => {
  const { t } = useTranslation('common')

  return (
    <ProgressStepContainer className={className}>
      <ProgressStepTitleAndDescription>
        <h2>{t('Generating Your Image...')}</h2>
        <p>
          {t(
            'The image will be automatically generated in a few seconds.',
          )}
        </p>
      </ProgressStepTitleAndDescription>

      <DummyProgress isCompleted={isCompleted} duration={60} />
    </ProgressStepContainer>
  )
}
